var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEteindreLaTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.375 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 892",
    d: "M27.401 12h-6.342l3.61 3.61h23.784a2.607 2.607 0 0 1 2.6 2.6V42l3.61 3.61V18.213A6.218 6.218 0 0 0 48.453 12H32.47l5.722-7.052a1.083 1.083 0 1 0-1.682-1.365l-6.468 7.971L18.48.306a1.083 1.083 0 0 0-1.51 1.553Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 893",
    d: "m60.665 57.863-6.08-6.079c0-.016.008-.032.012-.047l-3.414-3.414v.059l-32.964-32.96h.059l-3.564-3.567h-.059L4.137 1.342A2.424 2.424 0 0 0 .71 4.769l7.133 7.132a6.14 6.14 0 0 0-5.419 6.087v32.407a6.139 6.139 0 0 0 6.131 6.13h40.062a6.087 6.087 0 0 0 3.043-.812l5.578 5.577a2.424 2.424 0 0 0 3.428-3.427m-12.049-4.9H8.554a2.574 2.574 0 0 1-2.566-2.568V17.988a2.574 2.574 0 0 1 2.566-2.566h2.81l37.528 37.524a2.545 2.545 0 0 1-.275.016",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEteindreLaTv);
export default __webpack_public_path__ + "static/media/eteindre-la-tv.132be72a300f90eb736396eb8b665d7b.svg";
export { ForwardRef as ReactComponent };